import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/SettingValueController/CreateSettingValueController";
import SettingValueService from "../../controller/SettingValueController/SettingValueController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ModuleService from "../../controller/ModuleController/ModuleController";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


function CreateSettingValue({ setting, onClose, onSuccess, SettingList }) {
    const { t } = useTranslation(); // Initialize the useTranslation hook
    const [formData, setFormData] = useState({ vc_ValueName: '', vc_Value: '', SettingID: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") { // Corrected the comparison operator
        accordTheme = "accordion-header-dark";
    }

    const [ModuleList, setModuleList] = useState([]);
    useEffect(() => {
        fetchModules();
        const fetchSettingValueById = async (settingId) => {
            try {

                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };
                const settingData = await SettingValueService.GetSettingValueByID(redirectCallback, settingId); // Fetch setting by ID

                setFormData({ vc_ValueName: settingData.vc_ValueName, 
                    vc_Value: settingData.vc_Value, 
                    SettingID: settingData.FK_Settings_ID, 
                    vc_ValueDescription: settingData.vc_ValueDescription,
                ModuleID:settingData.ModuleID }); // Populate form data with fetched setting
            } catch (error) {
                console.error('Error fetching settings:', error);
            }
        };

        if (setting) {
            fetchSettingValueById(setting); // Fetch setting if setting prop contains ID
        } else {
            setFormData({ vc_Name: '', bit_Protected: 0 }); // Reset form data if no setting ID is provided
        }
    }, [setting]);
    const fetchModules = async () => {
        try {
            const list = await ModuleService.GetAllModules();
            setModuleList(list);
        } catch (error) {
            console.error('Error fetching Projects:', error);
        }
    };

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission

        if (setting) {
            formData.ID = setting;
        } else {
            formData.ID = 0;
        }

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Value: content
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade show" id="settingModal" tabIndex="-1" aria-labelledby="settingModalLabel" aria-hidden="true" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{setting ? "Edit Setting Value" : "Add Setting Value"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Name</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_ValueName" value={formData.vc_ValueName} onChange={handleFieldChange} />
                                        {errors.vc_ValueName && <div style={{ color: 'red' }}>{errors.vc_ValueName}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Select Setting</label>
                                    <div className="col-sm-4">
                                        <select name="SettingID" className='form-control' value={formData.SettingID} onChange={handleFieldChange}>
                                            <option value="0">Select Setting</option>
                                            {SettingList.map((setting) => (
                                                <option key={setting.PK_Settings_ID} value={setting.PK_Settings_ID}>
                                                    {setting.vc_Name}
                                                </option>
                                            ))}
                                        </select>

                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>


                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Select Module</label>
                                    <div className="col-sm-4">
                                        <select name="ModuleID" className='form-control' value={formData.ModuleID} onChange={handleFieldChange}>
                                            <option value="0">Select Module</option>
                                            {ModuleList.map((module) => (
                                                <option key={module.PK_SearchModule_ID} value={module.PK_SearchModule_ID}>
                                                    {module.vc_ModuleName}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Value</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_Value" value={formData.vc_Value} onChange={handleFieldChange} />
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true">  {setting ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-bs-dismiss="modal" onClick={onClose}>
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}


export default CreateSettingValue;